export class NexoCryptoException implements Error {
    public readonly message: string;
    public readonly name: string;

    public constructor(message: string) {
        this.name = "NexoCryptoException";
        this.message = message;
    }
}
